<template>
  <div class="photos">
    <div class="wrapper">
      <h1>Фотогалерея</h1>
      <p>Раздел в процессе разработки</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Photos"
}
</script>

<style lang="scss">

</style>